import { render, staticRenderFns } from "./F2.vue?vue&type=template&id=79be72c1&scoped=true"
import script from "./F2.vue?vue&type=script&lang=js"
export * from "./F2.vue?vue&type=script&lang=js"
import style0 from "./F2.vue?vue&type=style&index=0&id=79be72c1&prod&lang=less&scoped=true"
import style1 from "./F2.vue?vue&type=style&index=1&id=79be72c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79be72c1",
  null
  
)

export default component.exports